// صف الإجماليات أسفل جدول تقرير الرواتب — يطابق أرقام البطاقات بنظرة واحدة.
import { esc, formatCurrency } from "./reportFormat";

const sum = (rows, pick) => rows.reduce((total, row) => total + (Number(pick(row)) || 0), 0);
const leaves = (row) => Object.values(row.leave_breakdown || {}).reduce((n, i) => n + (i.count || 0), 0);

export const totalsRow = (data, L) => {
  const rows = data.employees || [];
  if (!rows.length) return "";
  const c = data.currency;
  const deductions = sum(rows, (r) => r.deductions_total);
  const net = sum(rows, (r) => r.accumulated_salary);
  return `<tfoot><tr class="totals">
    <td class="b">${esc(L.totalsLabel)} (${rows.length})</td>
    <td>${esc(formatCurrency(sum(rows, (r) => r.base_salary), c))}</td>
    <td>—</td>
    <td>${sum(rows, (r) => r.days_worked)}</td>
    <td>${sum(rows, (r) => r.total_weekends)}/${sum(rows, (r) => r.paid_weekends)}</td>
    <td>${sum(rows, leaves)}</td>
    <td>${sum(rows, (r) => r.compensation_days)}</td>
    <td>${sum(rows, (r) => r.total_paid_days)}</td>
    <td>${sum(rows, (r) => r.absence_days)}</td>
    <td>${sum(rows, (r) => r.late_count)}</td>
    <td>${deductions ? `-${esc(formatCurrency(deductions, c))}` : esc(formatCurrency(0, c))}</td>
    <td>${esc(formatCurrency(sum(rows, (r) => r.advance_installment), c))}</td>
    <td>${esc(formatCurrency(net, c))}</td>
  </tr></tfoot>`;
};
